import { airingCalendar } from '@/mocks/dramas';
import { useState } from 'react';

const highlight = ['暗河长明', '半夏有晴天', '长安十二时辰·续'];

export default function Calendar() {
  const todayIdx = 4; // 周五作为示例"今天"
  const [active, setActive] = useState(todayIdx);

  const activeDay = airingCalendar[active];
  const isHighlight = (t: string) => highlight.includes(t);

  return (
    <section id="calendar" className="scroll-mt-20 bg-[#f3ecdf]/50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#e85d3f]">更新提醒快人一步 · 追更不迷路</p>
          <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">本周追更日历</h2>
          <p className="mt-3 text-sm leading-6 text-[#6f655a]">
            蹲点守候不如关注这里。每周更新节奏一目了然，按剧集提前规划，今晚追哪部、明晚补哪集，再也不怕错过高光时刻。
          </p>
        </div>

        <div className="grid gap-5 lg:grid-cols-[1fr_300px]">
          <div className="grid grid-cols-7 gap-2">
            {airingCalendar.map((d, i) => (
              <button
                key={d.day}
                onClick={() => setActive(i)}
                className={`flex flex-col items-center rounded-xl px-1 py-3 transition-colors ${
                  active === i ? 'bg-[#26201a] text-white' : 'bg-white text-[#6f655a] hover:bg-white/80'
                }`}
              >
                <span className={`mb-1 text-xs ${i === todayIdx ? 'font-bold text-[#e85d3f]' : ''}`}>周{d.day}</span>
                <span className="text-[10px] text-[#a3988a]">{d.list.length} 部更新</span>
              </button>
            ))}
          </div>

          <div className="rounded-2xl border border-[#26201a]/8 bg-white p-5">
            <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-[#a3988a]">周{activeDay.day} 更新清单</p>
            <ul className="space-y-3">
              {activeDay.list.map((t) => (
                <li key={t} className="flex items-center gap-3">
                  <span className="flex h-2.5 w-2.5 items-center justify-center rounded-full bg-[#3e7c59]">
                    <i className="ri-check-line text-[8px] text-white"></i>
                  </span>
                  <span className={`text-sm font-medium ${isHighlight(t) ? 'text-[#26201a]' : 'text-[#6f655a]'}`}>{t}</span>
                  {isHighlight(t) && (
                    <span className="ml-auto rounded-full bg-[#e85d3f]/10 px-2 py-0.5 text-[10px] font-semibold text-[#e85d3f]">
                      今晚高光
                    </span>
                  )}
                </li>
              ))}
            </ul>
            <a
              href="#subscribe"
              className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#26201a] px-4 py-2.5 text-xs font-semibold text-white hover:bg-[#e85d3f]"
            >
              <i className="ri-notification-3-line"></i> 开启每日提醒
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}